<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Рестораны</strong>
                    <CLink to="/restaurants/archive" class="float-right">Архив</CLink>
                </CCardHeader>

                <CCardBody>
                    <div class="flex flex-row-reverse mb-2">
                        <CButton v-if="adminOnly" color="primary" @click="$router.push('/restaurants/create')">Создать</CButton>
                    </div>
                    <div class="flex align-items-center mb-4">
                        <div class="mr-4">Сортировка по башням</div>
                        <CSwitch color="dark" shape="pill" variant="opposite" class="mr-4" :checked="towerReorderShow" @update:checked="setTowerReorderShow" hide-details />
                        <CSelect
                            horizontal
                            v-if="towerReorderShow"
                            :options="towersOptions"
                            :value.sync="selectedTower"
                            @change="selectTower"
                            placeholder="Выберите башню..."
                            class="mb-0"
                            hide-details
                        />
                        <div class="text-danger" v-if="showDefaultOrder">Сортировка для этой башни не сохранена. Используется дефолтная.</div>
                    </div>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <CompaniesTable :data.sync="list" :service="'restaurants'" archivable @archived="fetch" />
                    </template>
                </CCardBody>

                <CCardFooter v-if="adminOnly">
                    <div v-if="list && list.length && list[0].temporary_delivery_time && deliveryTime">
                        <CRow class="pl-3 mb-3 mt-3" style="color: red"> Время доставки увеличено до: {{ deliveryTime }} </CRow>
                    </div>
                    <CButton color="primary" @click="$router.push('/restaurants/create')">Создать</CButton>

                    <CButton class="ml-4" color="info" @click="reorder">Сохранить расположение</CButton>
                    <CButton class="ml-4" color="danger" @click="openDeliveryModal = true">Увеличить время доставки</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <DeliveryModal
            ref="deliveryModal"
            :open.sync="openDeliveryModal"
            :list="list"
            :type="BUSINESS_TYPE.RESTAURANT"
            @stop-modal-close="openDeliveryModal = false"
            @stop-modal-update="setDeliveryTime"
        />
    </CRow>
</template>

<script>
import CompaniesTable from '@/components/CompaniesTable';
import DeliveryModal from '@/components/DeliveryModal';
import { BUSINESS_TYPE } from '@/utils/order';
import moment from 'moment';

export default {
    name: 'Restaurants',

    components: {
        CompaniesTable,
        DeliveryModal,
    },

    data: () => ({
        loading: true,
        list: [],
        openDeliveryModal: false,
        BUSINESS_TYPE,
        deliveryTime: '',
        towers: [],
        towerReorderShow: false,
        selectedTower: null,
        showDefaultOrder: false
    }),

    computed: {
        adminOnly() {
            return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
        },
        towersOptions: function () {
            return this.towers
                ? this.towers.map((item) => {
                      return {
                          value: item.id,
                          label: item.name,
                      };
                  })
                : [];
        },
    },

    async created() {
        await this.fetch();
        const { data } = await this.axios.get('/address');
        this.towers = data;
        this.loading = false;
    },

    methods: {
        async fetch() {
            this.showDefaultOrder = false;
            try {
                const { data } = await this.axios.get('/restaurants');
                this.list = data;
                if (this.list?.length) {
                    const time = (this.deliveryTime = moment(this.list[0].temporary_delivery_time).format('HH:mm'));
                    const isNow = moment().isSameOrBefore(moment(this.list[0].temporary_delivery_time).set({ hour: 23, minute: 59 }));
                    if (isNow && time) {
                        this.deliveryTime = time;
                    } else {
                        this.deliveryTime = null;
                    }
                }
            } catch (err) {
                console.log(err, 'err');
                this.$root.$emit('showError', 'Ошибка загрузки данных.');
            }
        },
        openDialog() {
            this.$refs.upsertDialog.open();
        },
        async setTowerReorderShow(enabled) {
            this.towerReorderShow = enabled;
            if (!enabled) {
                await this.fetch();
            }
        },
        async selectTower(e) {
            this.loading = true;
            this.showDefaultOrder = false;
            this.selectedTower = e.target.value;
            console.log(this.selectedTower);
            const { data } = await this.axios.get(`/entity-sort-for-tower/restaurant/${this.selectedTower}`);
            if (data && data.length) {
                this.list = this.list
                    .map((item) => {
                        const reorderItem = data.find((reorderItem) => {
                            return item.id === reorderItem.entity_id;
                        });
                        if (reorderItem) {
                            return {
                                ...item,
                                reorder_id: reorderItem.id,
                                position: reorderItem.position,
                            };
                        }
                        return {
                            ...item,
                            position: 0,
                        };
                    })
                    .sort((a, b) => a.position - b.position);
            } else {
                await this.fetch();
                this.showDefaultOrder = true;
            }
            this.loading = false;
        },
        async reorder() {
            try {
                if (this.towerReorderShow && this.selectedTower) {
                    const reorder = this.list.map((item) => {
                        return {
                            id: item.reorder_id,
                            type: 'restaurant',
                            tower_id: +this.selectedTower,
                            entity_id: item.id,
                            position: item.position,
                        };
                    });
                    await this.axios.post('/entity-sort-for-tower/restaurant', { reorder });
                } else {
                    const payload = {
                        reorder: this.list.map((item, idx) => ({ id: item.id, position: idx + 1, title: item.title })),
                    };
                    await this.axios.post('/restaurants/reorder', payload);
                }
                this.$root.$emit('showAlert', 'Порядок успешно изменен.');
            } catch (err) {
                this.$root.$emit('showError', 'Ошибка сохранения порядка.');
            }
        },
        setDeliveryTime(time) {},
    },
};
</script>
